import { defineStore } from "pinia";
import { ref, computed } from "vue";
import api from "../services/api";
import { useAuthStore } from "./auth";

export const useSubscriptionStore = defineStore("subscription", () => {
  const subscription = ref(null);
  const plan = ref(null);
  const loading = ref(false);
  const checkoutLoading = ref(false);

const isActive = computed(() => {
  const auth = useAuthStore();
  return (
    auth.user?.isAdmin === true ||
    (subscription.value &&
      ["active", "trialing"].includes(subscription.value.status))
  );
});

  const isCanceling = computed(
    () => subscription.value?.cancelAtPeriodEnd === 1
  );

  const periodEnd = computed(() =>
    subscription.value?.currentPeriodEnd
      ? new Date(subscription.value.currentPeriodEnd).toLocaleDateString(
          "da-DK",
          {
            year: "numeric",
            month: "long",
            day: "numeric",
          }
        )
      : null
  );

  async function fetchStatus() {
    loading.value = true;
    try {
      const { data } = await api.get("/subscription");
      subscription.value = data.subscription;
      plan.value = data.plan;
    } catch (error) {
      console.error("Failed to fetch subscription:", error);
    } finally {
      loading.value = false;
    }
  }

  async function checkout(provider, interval) {
    checkoutLoading.value = true;
    try {
      const { data } = await api.post("/subscription", { provider, interval });
      if (data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      }
      return data;
    } finally {
      checkoutLoading.value = false;
    }
  }

  async function cancel() {
    const { data } = await api.post("/subscription/cancel");
    await fetchStatus();
    return data;
  }

  async function openPortal() {
    const { data } = await api.post("/subscription/portal");
    if (data.url) {
      window.location.href = data.url;
    }
  }

  return {
    subscription,
    plan,
    loading,
    checkoutLoading,
    isActive,
    isCanceling,
    periodEnd,
    fetchStatus,
    checkout,
    cancel,
    openPortal,
  };
});
